$(document).ready(function () {
	$('.btn-delete-location').click(function () {
		let route = $(this).attr('href');

		let $form = $("<form action='"+route+"' method='post'></form>")
			.append('<input type="hidden" name="_method" value="delete">')
			.append('<input type="hidden" name="_token" value="'+App.csrf+'">')
			.appendTo($('body'));

		$form.submit();

		return false;
	});
});